var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRightSector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 29,
    viewBox: "0 0 17 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.791386 0.813747C0.284507 1.32918 -1.17905e-06 2.02643 -1.14728e-06 2.75321C-1.11552e-06 3.47998 0.284507 4.17723 0.791386 4.69267L10.4254 14.5688L0.791387 24.3073C0.284508 24.8228 -1.52115e-07 25.52 -1.20346e-07 26.2468C-8.85779e-08 26.9736 0.284508 27.6708 0.791387 28.1863C1.04438 28.4441 1.34538 28.6488 1.67702 28.7884C2.00866 28.9281 2.36437 29 2.72364 29C3.08291 29 3.43862 28.9281 3.77026 28.7884C4.1019 28.6488 4.4029 28.4441 4.6559 28.1863L16.195 16.522C16.4501 16.2662 16.6525 15.962 16.7907 15.6267C16.9289 15.2915 17 14.9319 17 14.5688C17 14.2056 16.9289 13.846 16.7907 13.5108C16.6525 13.1756 16.4501 12.8713 16.195 12.6156L4.65589 0.813747C4.4029 0.555898 4.1019 0.35124 3.77026 0.211576C3.43862 0.0719107 3.08291 1.77259e-06 2.72364 1.78829e-06C2.36437 1.804e-06 2.00866 0.0719108 1.67702 0.211576C1.34538 0.35124 1.04438 0.555899 0.791386 0.813747Z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightSector);
export default __webpack_public_path__ + "static/media/iconArrowRightSector.f96764438f9adc047b587fd003f5b5d8.svg";
export { ForwardRef as ReactComponent };